import React from "react";
import { colorOptions, soundOptions } from "../utils";
import { Note } from "./icons/Note";
import { Pause } from "./icons/Pause";

export const ModalSound = ({ sound, setSound, soundPlaying, setClicked }) => {
  return (
    <div className="modal-sound">
      <p>Select sound</p>
      <div className="modal-sound-options">
        {soundOptions.map((c, i) => (
          <div key={i} className="sound-option-container">
            <input
              type="radio"
              name="sound"
              value={c}
              id={c}
              onClick={({ target }) => {
                setSound(
                  sound === target.value && soundPlaying
                    ? "doPause"
                    : sound === target.value
                    ? "doPlay"
                    : target.value
                );
                setClicked(true);
              }}
              className="sound-option"
            />
            <label
              htmlFor={c}
              className={`${colorOptions[i]}  sound-option-label`}
            >
              {soundPlaying && sound === c ? (
                <Pause size={sound === c ? 30 : 20} fill="var(--light)" />
              ) : (
                <Note size={sound === c ? 30 : 20} fill="var(--light)" />
              )}
            </label>
            <span className="sound-title capitalize">{c}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
